export default {
  badge: 'Bricka',
  open: 'Open',
  close: 'Stäng',
  dismiss: 'Dismiss',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Avbryt',
  },
  dataIterator: {
    noResultsText: 'Hittade inga poster',
    loadingText: 'Laddar data...',
  },
  dataTable: {
    itemsPerPageText: 'Rader per sida:',
    ariaLabel: {
      sortDescending: 'Fallande sortering.',
      sortAscending: 'Stigande sortering.',
      sortNone: 'Osorterat.',
      activateNone: 'Aktivera för att ta bort sortering.',
      activateDescending: 'Aktivera för att sortera fallande.',
      activateAscending: 'Aktivera för att sortera stigande.',
    },
    sortBy: 'Sortera efter',
  },
  dataFooter: {
    itemsPerPageText: 'Objekt per sida:',
    itemsPerPageAll: 'Alla',
    nextPage: 'Nästa sida',
    prevPage: 'Föregående sida',
    firstPage: 'Första sidan',
    lastPage: 'Sista sidan',
    pageText: '{0}-{1} av {2}',
  },
  dateRangeInput: {
    divider: 'to',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Välj datum',
      header: 'Välj datum',
    },
    title: 'Välj datum',
    header: 'Välj datum',
    input: {
      placeholder: 'Välj datum',
    },
  },
  noDataText: 'Ingen data tillgänglig',
  carousel: {
    prev: 'Föregående vy',
    next: 'Nästa vy',
    ariaLabel: {
      delimiter: 'Karusellvy {0} av {1}',
    },
  },
  calendar: {
    moreEvents: '{0} fler',
    today: 'Today',
  },
  input: {
    clear: 'Rensa {0}',
    prependAction: '{0} prepended action',
    appendAction: '{0} appended action',
    otp: 'Please enter OTP character {0}',
  },
  fileInput: {
    counter: '{0} filer',
    counterSize: '{0} filer ({1})',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Select Time',
  },
  pagination: {
    ariaLabel: {
      root: 'Paginering',
      next: 'Nästa sida',
      previous: 'Föregående sida',
      page: 'Gå till sida {0}',
      currentPage: 'Aktuell sida, sida {0}',
      first: 'Första sidan',
      last: 'Sista sidan',
    },
  },
  stepper: {
    next: 'Next',
    prev: 'Previous',
  },
  rating: {
    ariaLabel: {
      item: 'Betyg {0} av {1}',
    },
  },
  loading: 'Loading...',
  infiniteScroll: {
    loadMore: 'Load more',
    empty: 'No more',
  },
}
